import { SIDE_BAR_ITEM } from 'app/config/constants';
import { MenuItemDTO } from '../model/MenuItemDTO.model';

export function isEmptyObject(obj) {
  return !(typeof obj === 'object' && obj != null && Object.keys(obj).length !== 0);
}

export function isEmptyArray(array) {
  return !(Array.isArray(array) && array?.length > 0);
}
export function checkEmptyObjectAttributes(obj) {
  return Object.values(obj).every(attribute => attribute !== undefined && attribute !== null && attribute !== '');
}
export const capitalize = (param: string) => {
  if (param) return param.charAt(0).toUpperCase() + param.slice(1).toLowerCase();
};

export const setBarItemsUrl = (items: any[], data: MenuItemDTO[]): any[] => {
  if (items !== undefined && items !== null && Object.keys(items).length !== 0) {
    data.forEach(element => {
      const { label, icon, code } = items?.find(i => i.code === SIDE_BAR_ITEM[element.barItem]);
      element.label = label;
      element.icon = icon;
      element.code = code;
    });
  }
  return data;
};

export const findDeliveryAddress = (subscriber): any => {
  if (subscriber?.shippingAddress) {
    return subscriber.shippingAddress;
  } else if (subscriber?.address) {
    return subscriber.address;
  }
  return null;
};

export const getInsuredGoodFeature = (insuredGood, code): any => {
  if (insuredGood?.features) {
    const detail = insuredGood?.features[code];
    return detail;
  } else {
    return null;
  }
};

export function arraysEqual(array1: any[], array2: any[]): boolean {
  for (let i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) {
      return false;
    }
  }
  return true;
}

export function checkFormatSubscriptionNumber(subscriptionNumber: string): boolean {
  const formatSubscriptionNumber = /^([0-9]{12})$/;
  return formatSubscriptionNumber.test(subscriptionNumber);
}

export function containsOnlyNumber(str: string) {
  const re = /^[0-9\b]+$/;
  return str === '' || re.test(str);
}

export function isMobileDevice() {
  let hasTouchScreen = false;

  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator['maxTouchPoints'] > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = navigator['maxTouchPoints'] > 0;
  } else {
    const mQ = matchMedia('(pointer:coarse)');

    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing

      const UA = navigator['userAgent'];

      hasTouchScreen = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }

  return hasTouchScreen;
}

export const noLog = () => {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
};
